import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

import { useAuth } from '../hooks/useAuth';
import { useRushLeaderboard } from '../hooks/useRushLeaderboard';
import { RushLeaderboard } from '../components/trivia-rush/RushLeaderboard';
import { RushWavyGrid } from '../components/trivia-rush/RushWavyGrid';
import { UserModal } from '../components/ui/modals/UserModal';
import { OnboardingSurveyGate } from '../components/OnboardingSurveyGate';

export const RushLeaderboardPage: React.FC = () => {
  const { user } = useAuth();
  const { entries, currentUser, isLoading, hasMore, loadMore, loadingMore } =
    useRushLeaderboard();
  const [showUserModal, setShowUserModal] = useState(false);

  return (
    <>
      <Helmet>
        <title>Wallstreetle | Trivia Rush Leaderboard</title>
        <meta
          name="description"
          content="See the top Trivia Rush high scores. Can you beat the leaderboard?"
        />
      </Helmet>

      <div
        className="min-h-screen flex flex-col relative"
        style={{ backgroundColor: 'var(--rush-bg-primary)' }}
      >
        <RushWavyGrid />

        {/* Back button */}
        <div className="relative z-[1] px-4 pt-4">
          <Link
            to="/trivia-rush"
            className="inline-flex items-center gap-1 text-sm font-medium transition-opacity hover:opacity-80"
            style={{ color: 'var(--rush-text-muted)' }}
          >
            <ChevronLeft size={18} />
            Back
          </Link>
        </div>

        {/* Content */}
        <div className="w-full max-w-[480px] mx-auto px-4 pt-4 pb-6 flex-1 relative z-[1]">
          <RushLeaderboard
            entries={entries}
            currentUser={currentUser}
            isLoading={isLoading}
            hasMore={hasMore}
            loadMore={loadMore}
            loadingMore={loadingMore}
            isAuthenticated={!!user}
            onSignInClick={() => setShowUserModal(true)}
          />
        </div>
      </div>

      <UserModal
        isOpen={showUserModal}
        onClose={() => setShowUserModal(false)}
        className="rush-theme"
      />
      <OnboardingSurveyGate />
    </>
  );
};
